import { render, staticRenderFns } from "./ComponentsCatalogComponent.vue?vue&type=template&id=01eaacac&"
import script from "./ComponentsCatalogComponent.vue?vue&type=script&lang=js&"
export * from "./ComponentsCatalogComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports